// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__34lcU","head":"Table_head__3fnfY","col":"Table_col__xY-ZL"};